import store from "../store/store";

// @TODO safari lock screen player shows those

export const Sounds = {
  HMM: new Audio(`${process.env.PUBLIC_URL}/audio/hmm.ogg`),
  POSITIVE: new Audio(`${process.env.PUBLIC_URL}/audio/positive.ogg`),
  NEGATIVE: new Audio(`${process.env.PUBLIC_URL}/audio/negative.ogg`),
  SCRATCH: new Audio(`${process.env.PUBLIC_URL}/audio/scratch.ogg`),
  CLICK: new Audio(`${process.env.PUBLIC_URL}/audio/button-click.mp3`),
}

export const playSound = (sound: HTMLAudioElement) => {

  const userState = store.getState().user;

  if (userState.user.soundsEnabled) {
    sound.currentTime = 0;
    sound.play();
  }

}

/* const createAudio = (src: string) => {

  const audioSettings = {
    volume: 0.5,
  };

  return  Object.assign(document.createElement('audio'), { src: src, ...audioSettings});
}

export const Sounds = {
  HMM:  createAudio('/audio/hmm.ogg'),
  UNCONVINCED:  createAudio('/audio/unconvinced.ogg'),
  DONT_THINK_SO:  createAudio('/audio/dont-think-so.ogg'),
  SCRATCH:  createAudio('/audio/scratch.ogg'),
  CLICK:  createAudio('interface-click.wav'),
} */